export default "__VITE_ASSET__c0b9f40e__$_?component__"